export default __webpack_public_path__ + "static/media/eatingtimes_1@2x.e6691d3c.jpg";